// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"402":"f471b06b","819":"ab2fb6ae"}[chunkId] + ".chunk.css";
};